import { render, staticRenderFns } from "./m-lock-modal.vue?vue&type=template&id=28f2f27b&scoped=true&"
import script from "./m-lock-modal.vue?vue&type=script&lang=ts&setup=true&"
export * from "./m-lock-modal.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./m-lock-modal.vue?vue&type=style&index=0&id=28f2f27b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f2f27b",
  null
  
)

export default component.exports